import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import getLogger from "utils/logger.util.js";
import { AnalyticsStrings } from "constants/constantStrings.js";

import AgTable from "components/AgTable";
import BadgeLabel from "components/BadgeLabel/index.js";

import { getCleaningRequiredTableColDef } from "./CIPCleaningRequiredTable.config.js";

const AnalyticsCleaningRequiredTable = ({ analyticsRawData }) => {
  const Logger = getLogger("AnalyticsCleaningRequiredTable");
  const { tagsAsObj } = useSelector(state => state.tags);
  const [isCIPEvents, setIsCIPEvents] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [cleaningColDef] = useState(getCleaningRequiredTableColDef(true));
  const initialBaseline = Object.values(tableData)?.[0]?.Baseline_Value;

  useEffect(() => {
    setIsCIPEvents(analyticsRawData.CIP_Events.length);
  }, [analyticsRawData.CIP_Events]);

  useEffect(() => {
    try {
      let formattedData = [];
      if (analyticsRawData?.Normalized_Tag_Exceptions) {
        formattedData = analyticsRawData.Normalized_Tag_Exceptions.map(item => {
          const { TagName, Units } = tagsAsObj[item.Tag];
          return { ...item, TagName: `${TagName} (${Units})` };
        });
        setTableData(formattedData);
      }
    } catch (err) {
      Logger.error("Error while formatting tag: ", err);
    }
  }, [analyticsRawData?.Normalized_Tag_Exceptions]);

  return (
    <div className="cleaning-required">
      <div className="cleaning-required--header">
        <BadgeLabel badgeDescription={AnalyticsStrings.CIP_Cleaning_Required} />
        {/* We may need this code in furture, so keeping it as commented */}
        {/* <div className="descriptionText note-item">{AnalyticsStrings.CIP_Cleaning_Required_Note}</div> */}
      </div>
      {isCIPEvents || initialBaseline ? (
        <>
          <AgTable rowData={tableData} columnDefs={cleaningColDef} />
          <span className="descriptionText note-item"> {AnalyticsStrings.CIP_Cleaning_Required_Values_Note}</span>
        </>
      ) : (
        <label className="dupont-form-label">{AnalyticsStrings.noDataMsg}</label>
      )}
    </div>
  );
};

export default AnalyticsCleaningRequiredTable;
